/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Poly6IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Poly6Icon(props: Poly6IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 104 145"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeLinejoin={"round"}
        strokeWidth={"2"}
        d={
          "m13.405 1 77.717 15.429 10.946 64.414-20.798 48.214-62.756 14.272L1 80.843z"
        }
      ></path>
    </svg>
  );
}

export default Poly6Icon;
/* prettier-ignore-end */
